<div [id]="field.attributes.id" [class.compact]="hasALotOptions" class="group">
  @for (option of options; track option) {
  <div
    (click)="updateModel(option.id)"
    class="bordered-box"
    [class.active]="field.control.value.id === option.id"
  >
    <label>
      <input
        type="radio"
        name="contactChoice"
        [value]="option.id"
        [ngModel]="field.control.value.id"
        (ngModelChange)="updateModel(option.id)"
      />
    </label>
    <div class="option-text">
      <h3>{{ option.first_name }} {{ option.last_name }}</h3>
      <div>{{ option.job_title }}</div>
      <div>{{ option.responsibility }}</div>
      @if (option.contact_types) {
      <div>
        <icon type="tag-fill"></icon>
        <b
          ><u>{{ option.contact_types }}</u></b
        >
      </div>
      } @if (option.telephone_work) {
      <div>
        <icon type="house"></icon>
        {{ option.telephone_work | telephone }}
      </div>
      } @if (option.email) {
      <div class="email">
        <icon type="envelope-fill"></icon>
        {{ option.email }}
      </div>
      }
    </div>
  </div>
  }

  <!-- CUSTOM -->
  @if (field.attributes.support_custom) {
  <div class="bordered-box">
    <div (click)="updateModelWithCustom()" [class.active]="isCustomSelected()">
      <label>
        <input [checked]="isCustomSelected()" type="radio" />
      </label>
      <div class="custom-option option-text">
        <label>
          <input
            (change)="updateModelWithCustom()"
            [formControl]="name"
            type="text"
            placeholder="Name"
            [disabled]="!isCustomSelected()"
            [required]="true"
            class="form-control"
          />
        </label>
        <label>
          <input
            (change)="updateModelWithCustom()"
            [formControl]="telephone"
            type="text"
            placeholder="Telephone"
            [disabled]="!isCustomSelected()"
            [required]="true"
            class="form-control"
          />
        </label>
        <label>
          <input
            [(ngModel)]="email"
            (change)="updateModelWithCustom()"
            [formControl]="email"
            type="email"
            placeholder="Email"
            [disabled]="!isCustomSelected()"
            [required]="true"
            class="form-control"
          />
        </label>
      </div>
    </div>
  </div>
  }
</div>
